// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================
'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { createUrlFromPattern } from '@cntxt/domains/access-control';
import type { UpdateEvents } from '@cntxt/shared/infrastructure/sse';
import { useLiveData } from '@cntxt/shared/infrastructure/sse';
import { API_BASE } from '../../../shared/constants';
import type { EndpointData } from '../api/getNotificationsStream';
import { useInvalidateNotifications } from '../queries/useInvalidateNotifications';
const SSE_MAX_RETRIES = 2;
const SSE_RETRY_MS = 2_000;

/**
 * Resolves the SSE URL for getNotificationsStream.
 */
export const getNotificationsStreamUrl = (): string => {
  return createUrlFromPattern(`${API_BASE}notifications/stream`, {});
};
type UseGetNotificationsStreamSubscriptionParams = {
  enabled?: boolean;
  onMessage?: (message: EndpointData, eventType: UpdateEvents) => void;
  onError?: (error: string) => void;
};

/**
 * Subscribes to getNotificationsStream via Server-Sent Events.
 *
 * Invalidates related React Query caches on each event.
 */
export const useGetNotificationsStreamSubscription = t0 => {
  const $ = _c(10);
  const {
    enabled: t1,
    onMessage,
    onError
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const invalidateNotifications = useInvalidateNotifications();
  let t2;
  if ($[0] !== invalidateNotifications || $[1] !== onMessage) {
    t2 = (message, eventType) => {
      invalidateNotifications();
      onMessage?.(message, eventType);
    };
    $[0] = invalidateNotifications;
    $[1] = onMessage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleMessage = t2;
  let t3;
  if ($[3] !== enabled) {
    t3 = enabled ? getNotificationsStreamUrl() : "";
    $[3] = enabled;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== enabled || $[6] !== handleMessage || $[7] !== onError || $[8] !== t3) {
    t4 = {
      url: t3,
      onMessage: handleMessage,
      onError,
      enabled,
      retryMs: SSE_RETRY_MS,
      maxRetries: SSE_MAX_RETRIES
    };
    $[5] = enabled;
    $[6] = handleMessage;
    $[7] = onError;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useLiveData(t4);
};